import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  fullWidth = false,
  onClick,
  type = 'button',
  className = '',
  ...props
}) => {
  const baseClasses =
    'inline-flex items-center justify-center gap-2 font-medium rounded-lg ' +
    'transition-all duration-150 ease-out select-none ' +
    'focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white ' +
    'disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none ' +
    'active:scale-[0.98]';

  const variants = {
    primary:
      'bg-ink-900 text-white hover:bg-ink-800 shadow-soft hover:shadow-card',
    brand:
      'text-white shadow-soft hover:shadow-pop bg-gradient-to-b from-brand-500 to-brand-600 hover:from-brand-500 hover:to-brand-700',
    secondary:
      'bg-white text-ink-800 border border-ink-200 hover:bg-ink-50 hover:border-ink-300 shadow-soft',
    success:
      'bg-emerald-600 text-white hover:bg-emerald-700 shadow-soft',
    danger:
      'bg-rose-600 text-white hover:bg-rose-700 shadow-soft',
    outline:
      'border border-ink-200 text-ink-700 hover:bg-ink-50 hover:border-ink-300 bg-white',
    ghost:
      'text-ink-700 hover:bg-ink-100 hover:text-ink-900',
    link:
      'text-brand-600 hover:text-brand-700 underline-offset-4 hover:underline px-0 py-0 shadow-none',
  };

  const sizes = {
    small: 'px-3 py-1.5 text-xs',
    medium: 'px-4 py-2 text-sm',
    large: 'px-5 py-2.5 text-sm',
    xl: 'px-6 py-3 text-base',
  };

  const classes = [
    baseClasses,
    variants[variant] || variants.primary,
    sizes[size] || sizes.medium,
    fullWidth ? 'w-full' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading && (
        <svg
          className="animate-spin -ml-0.5 h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {children}
    </button>
  );
};

export default Button;
